// extracted by mini-css-extract-plugin
export default {"wrap":"chatPage_wrap__HCj6L","fixed":"chatPage_fixed__OJXSC"};